import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQSection.css';
import lawyerImage from '../../assets/images/Got query_ here are expert answers.jpg';

interface FAQItem {
    question: string;
    answer: string;
}

const FAQSection: React.FC = () => { 
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const faqs: FAQItem[] = [
        {
            question: 'What legal services do you offer in Coimbatore?',
            answer: 'We specialize in civil, property, consumer, arbitration, criminal, DRT, chit fund, insurance, banking, and electricity law services.​'
        },
        {
            question: 'Why choose your firm over others?',
            answer: 'Our experienced team provides personalized attention, proven results, exceptional communication, and up-to-date strategies for optimal outcomes.​'
        },
        {
            question: 'Do you offer free initial consultations?',
            answer: 'Yes, free consultations help assess your case, discuss options, and outline next steps without commitment.​'
        },
        {
            question: 'How long do legal cases typically take?',
            answer: 'Timelines vary by matter—simple disputes resolve in months, complex litigation may take 1-2 years.​'
        },
        {
            question: 'What are your fee structures?',
            answer: 'We use competitive, transparent fees, including contingency for claims and fixed rates for consultations and drafting.​'
        },
        {
            question: 'How experienced are your lawyers?',
            answer: 'Our lawyers bring extensive expertise in multiple practice areas, with a track record of courtroom success and client satisfaction.'
        }
    ];

    const toggleFAQ = (index: number) => {
        setOpenIndex(prev => prev === index ? null : index);
    };

    return (
        <section className="faq-section">
            <div className="container">
                <div className="faq-content">
                    {/* Left Column */}
                    <div className="faq-left">
                        <p className="faq-label">ABOUT</p>
                        <h2 className="faq-heading">
                            <span className="faq-highlight">Got query?</span> here are expert answers
                        </h2>
                        <p className="faq-description">
                            We've gathered the most frequently asked questions to help you better understand our legal services, consultation process, and how we handle cases.
                        </p>

                        {/* Need Help Card */}
                        <div className="need-help-card">
                            <div className="need-help-image">
                                <img src={lawyerImage} alt="Lawyer" />
                            </div>
                            <div className="need-help-content">
                                <h3>Need Help?</h3>
                                <p>We're here to answer any questions you may have.</p>
                                <Link className="talk-to-lawyer-btn" to="/contact" style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <b>Talk to a Lawyer</b>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 12h14M12 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - FAQ Accordion */}
                    <div className="faq-right">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${openIndex === index ? 'active' : ''}`}
                            >
                                <button
                                    type="button"
                                    className="faq-question"
                                    onClick={() => toggleFAQ(index)}
                                >
                                    {faq.question}
                                    <span className="faq-icon">
                                        {openIndex === index ? '−' : '+'}
                                    </span>
                                </button>
                                <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                                    <div className="faq-answer-inner">
                                        <p>{faq.answer}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
